export default __webpack_public_path__ + "assets/images/94134f063defb5ae6a6240a2fc2115b5.png";